module.exports = __webpack_public_path__ + "static/media/layout-5.ce33bb62.svg";